export const mutations = {
    setFooter(state, payload) {
        state.footer.top = payload.top;
        state.footer.bottom = payload.bottom;
    }
};